var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxVerifyState({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24144 0.156229C8.40043 0.0601625 8.59957 0.0601555 8.75857 0.15621L16.7585 4.98928C16.9084 5.07982 17 5.24215 17 5.41724V15.1233C17 15.2984 16.9084 15.4608 16.7585 15.5513L9.39474 20V10.0137C9.39474 9.83859 9.30313 9.67624 9.15324 9.58571L0.892947 4.59642L8.24144 0.156229ZM0 6.21446V15.1233C0 15.2984 0.0915881 15.4608 0.241454 15.5513L7.60526 20V11.0911C7.60526 10.916 7.51368 10.7537 7.36381 10.6631L0 6.21446Z",
    fill: "#14AC63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxVerifyState);
export default __webpack_public_path__ + "static/media/BoxVerifyState.4bb460ff17970c23087496ad3c6b956f.svg";
export { ForwardRef as ReactComponent };